/**
 * Texto que vai para o HIS (Tasy) só pode ter caracteres que ele lê: o que estiver fora da lista
 * chega como "¿" e o item não pode mais ser selecionado lá (FXCS-6863). Emoji, ®, ™, ©, º, ª, °
 * e caracteres invisíveis ficam de fora até a integração confirmar o que mais é aceito.
 */
const CARACTERES_NAO_PERMITIDOS = /[^\u0020-\u007E\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/g

// Texto colado de catálogo/PDF traz aspas, travessões e espaços tipográficos — vira o equivalente
// ASCII para não perder o sentido (ex.: 0.032” → 0.032").
const SUBSTITUICOES_TIPOGRAFICAS: [RegExp, string][] = [
  [/[\u201C\u201D\u201E\u2033\u00AB\u00BB]/g, '"'],
  [/[\u2018\u2019\u201A\u2032\u00B4]/g, '\''],
  [/[\u2010-\u2015\u2212]/g, '-'],
  [/[\u00A0\u2000-\u200A\u202F\u205F\u3000]/g, ' '],
  [/\u2026/g, '...'],
]

/**
 * O NFC junta letra + acento separados (comum em texto colado do macOS/PDF), senão a lista
 * de permitidos removeria o acento e "Ablação" viraria "Ablacao".
 */
const removeCaracteresEspeciais = (valor: string): string => SUBSTITUICOES_TIPOGRAFICAS
  .reduce((texto, [regex, substituto]) => texto.replace(regex, substituto), (valor || '').normalize('NFC'))
  .replace(CARACTERES_NAO_PERMITIDOS, '')

export default removeCaracteresEspeciais
